import { Tooltip } from "antd";
import styled from "styled-components";

export const StyledTooltip = styled(Tooltip).attrs(({ theme }) => ({
    color: theme.infoBackground,
}))``;
